module.exports = __webpack_public_path__ + "img/panel_feature_3_500X.1e481f11.jpg";